import * as React from "react";
import useLocation from "routing/useLocation";
import { OKTA_TYPE_KEY } from "authentication/components/oidc/constants";
import { DocumentTitle } from "components/common";
import WizardPageHeader from "components/authentication/directoryServices/ldap/WizardPageHeader";
import SectionComponent from "components/common/Section/SectionComponent";
import Routes from "routing/Routes";
import OidcBackendMetaProvider from "authentication/components/oidc/config/components/OidcBackendMetaProvider";
import LicenseCheck from "license/LicenseCheck";
import useHistory from "routing/useHistory";
import getDisplayName from "authentication/helpers/getDisplayName";
import BackendWizard from "./BackendWizard";
import { handleCreate } from "./helpers/handleSubmit";
import payloadFromFormValues from "./helpers/payloadFromFormValues";
const BackendCreate = () => {
  const location = useLocation();
  const backendType = location.pathname.substring(location.pathname.lastIndexOf("/") + 1);
  const isOkta = backendType === OKTA_TYPE_KEY;
  const displayName = getDisplayName(backendType);
  const history = useHistory();
  const onSubmitForm = (values, shouldUpdateGroupSync) => handleCreate(payloadFromFormValues(values), values, shouldUpdateGroupSync).then(() => {
    history.push(Routes.SYSTEM.AUTHENTICATION.BACKENDS.OVERVIEW);
  }).catch((error) => {
    throw error;
  });
  const title = `Create ${displayName} Authentication Service`;
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title }, /* @__PURE__ */ React.createElement(WizardPageHeader, { title }), /* @__PURE__ */ React.createElement(SectionComponent, { title }, /* @__PURE__ */ React.createElement(LicenseCheck, null, ({ licenseIsValid }) => /* @__PURE__ */ React.createElement(
    OidcBackendMetaProvider,
    {
      defaultValue: { backendId: void 0, backendGroupSyncIsActive: false, licenseIsValid }
    },
    /* @__PURE__ */ React.createElement(
      BackendWizard,
      {
        onSubmitForm,
        groupSyncValues: {},
        backendType,
        isOkta
      }
    )
  ))));
};
export default BackendCreate;
